import { Record } from 'immutable';
import { schema } from 'normalizr';

export const MonthlyInternationalPowerMeterReport = new Record({
  id: undefined,
  report_date: undefined,
  consumed_energy: undefined,
  site: undefined,
});

export const monthlyInternationalPowerMeterReportSchema = new schema.Entity('monthlyInternationalPowerMeterReports');

// for reading in nested models, object with { field: schema }
// monthlyInternationalPowerMeterReportSchema.define({  });
